import {DecarbonizationType, DecarbonizationTypeRegion} from "./decarbonization.model";

export class VehicleType extends DecarbonizationType {

  public static fromDto(vt): VehicleType {
    if (vt == null) {
      return null;
    }

    const vehicleType = new VehicleType();
    vehicleType.id = vt.id;
    vehicleType.label = vt.label;
    return vehicleType;
  }
}

export class VehicleTypeRegion extends DecarbonizationTypeRegion {

  public vehicleTypeId: string;

  public static fromDto(vt): VehicleTypeRegion {
    if (vt == null) {
      return null;
    }

    const vehicleTypeRegion = new VehicleTypeRegion();
    vehicleTypeRegion.id = vt.id;
    vehicleTypeRegion.vehicleTypeId = vt.vehicle_type_id;
    vehicleTypeRegion.regionId = vt.region_id;
    vehicleTypeRegion.label = vt.label;
    return vehicleTypeRegion;
  }
}

